import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type ConsultationIconProps = SvgIconProps

export function ConsultationIcon(props: ConsultationIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Teleconsultation">
        <g>
          <g>
            <g id="XMLID_00000073682368164665091270000009359616853379448497_">
              <g>
                <path
                  style={{
                    fill: htmlColor || '#A7A9AC',
                  }}
                  d="M184.859,19.458v119.97c0,1.66-1.34,3-3,3h-60.63h-15.27h-12.13h-15.27h-60.38
						c-1.68,0-3.04-1.36-3.04-3.03V19.458c0-1.67,1.36-3.03,3.04-3.03h163.65C183.499,16.428,184.859,17.788,184.859,19.458z
						 M174.569,132.138V26.848H25.429v105.29h12.05h44.81h44.79H174.569z"
                />
                <polygon
                  style={{
                    fill: htmlColor || '#A7A9AC',
                  }}
                  points="141.139,173.288 141.139,183.568 58.859,183.568 58.859,173.288 74.289,173.288 
						125.499,173.288 					"
                />
                <path
                  style={{
                    fill: htmlColor || '#A7A9AC',
                  }}
                  d="M63.439,65.848c-0.68-0.73-1.6-1.84-2.4-3.36c-0.23-0.44-0.44-0.88-0.62-1.34
						c-2.12-5.38-0.92-11.8-0.64-12.83c5.08-19.29,39.54-20.57,44.96,0c0.28,1.04,1.51,7.59-0.71,12.99
						c-0.16,0.4-0.35,0.8-0.55,1.18c-0.8,1.52-1.72,2.63-2.39,3.36c0,0,0,0,0,0.01l-18.15-14.9l-0.68,6.33
						c-5.77-2.24-11.08-3.68-15.6-4.62c-0.65,1.38-1.3,3.01-1.82,4.92c-0.93,3.32-1.15,6.29-1.13,8.56
						c-0.09-0.1-0.19-0.19-0.27-0.29C63.439,65.848,63.439,65.848,63.439,65.848z"
                />
              </g>
              <g>
                <polygon
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeMiterlimit: 10,
                  }}
                  points="
						125.499,173.288 141.139,173.288 141.139,183.568 58.859,183.568 58.859,173.288 74.289,173.288 					"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="M105.959,143.258v12.12
						c0,3.33-2.73,6.06-6.06,6.06c-3.34,0-6.07-2.73-6.07-6.06v-12.12"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="M78.559,143.258v15.6
						c0,5.2-1.58,10.08-4.27,14.12"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="M121.229,143.258v15.6
						c0,5.2,1.58,10.08,4.27,14.12"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="M78.559,142.428h-60.38
						c-1.68,0-3.04-1.36-3.04-3.03V19.458c0-1.67,1.36-3.03,3.04-3.03h163.65c1.67,0,3.03,1.36,3.03,3.03v119.97c0,1.66-1.34,3-3,3
						h-60.63h-15.27h-12.13H78.559z"
                />
                <polygon
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeMiterlimit: 10,
                  }}
                  points="37.479,132.138 
						25.429,132.138 25.429,26.848 174.569,26.848 174.569,132.138 127.079,132.138 82.289,132.138 					"
                />
                <polyline
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeMiterlimit: 10,
                  }}
                  points="
						152.079,43.238 152.079,52.498 152.079,61.768 					"
                />
                <polyline
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeMiterlimit: 10,
                  }}
                  points="
						161.349,52.498 152.079,52.498 142.819,52.498 					"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M55.249,128.578h-5.93v-12.84c0-5.85,4.74-10.58,10.59-10.58h1.13c5.84,0,10.58,4.73,10.58,10.58v12.84h-6.77"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M58.309,103.578c0-1.16,0.18-2.27,0.5-3.32c1.41-4.57,5.67-7.89,10.71-7.89"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M95.759,92.368c5.17,0,9.51,3.5,10.8,8.25c0.26,0.94,0.4,1.93,0.4,2.96v9.29"
                />

                <circle
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  cx="107.769"
                  cy="121.358"
                  r="7.7"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M63.389,65.778c0.01,0.03,0.03,0.05,0.05,0.07"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M62.089,71.878c-0.6-1.64-2.7-0.63-4.3-4.47c-2.36-5.63,0.35-6.98,2.2-6.09"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M101.949,71.878c0.61-1.64,2.7-0.63,4.31-4.47c2.35-5.63-0.36-6.98-2.2-6.09"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M62.089,71.878c1.16,7.66,4.69,14.17,9.54,18.07c3.04,2.47,6.59,3.91,10.39,3.96c3.98-0.06,7.69-1.63,10.82-4.3
						c4.62-3.95,7.99-10.29,9.11-17.73"
                />

                <line
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  x1="71.939"
                  y1="67.468"
                  x2="76.629"
                  y2="67.468"
                />

                <line
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  x1="91.439"
                  y1="67.468"
                  x2="86.749"
                  y2="67.468"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M76.969,83.918c1.64,1.25,3.44,1.96,5.29,1.96s3.66-0.71,5.3-1.96"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M63.439,65.858c0.08,0.1,0.18,0.19,0.27,0.29c-0.02-2.27,0.2-5.24,1.13-8.56c0.52-1.91,1.17-3.54,1.82-4.92
						c4.52,0.94,9.83,2.38,15.6,4.62l0.68-6.33l18.15,14.9c0-0.01,0-0.01,0-0.01c0.67-0.73,1.59-1.84,2.39-3.36
						c0.2-0.38,0.39-0.78,0.55-1.18c2.22-5.4,0.99-11.95,0.71-12.99c-5.42-20.57-39.88-19.29-44.96,0
						c-0.28,1.03-1.48,7.45,0.64,12.83c0.18,0.46,0.39,0.9,0.62,1.34c0.8,1.52,1.72,2.63,2.4,3.36
						C63.439,65.848,63.439,65.848,63.439,65.858z"
                />

                <line
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  x1="96.069"
                  y1="53.608"
                  x2="96.069"
                  y2="61.068"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M37.479,129.768c0.87-13.4,9.44-24.7,21.33-29.51c2.19-0.89,4.49-1.55,6.87-1.97"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M66.099,98.218c4.63,3.93,10.21,6.23,16.14,6.25"
                />

                <line
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  x1="82.289"
                  y1="106.808"
                  x2="82.289"
                  y2="131.318"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M98.869,98.288c2.69,0.47,5.26,1.26,7.69,2.33c11.46,4.98,19.66,16.06,20.52,29.15"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M98.449,98.218c-4.62,3.93-10.21,6.23-16.13,6.25c-0.03,0-0.05,0-0.08,0"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M71.619,89.958c0,0-1.84,7.43-5.52,8.26c-0.08,0.02-0.16,0.04-0.25,0.05"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: htmlColor || '#000000',
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 10,
                  }}
                  d="
						M93.129,89.958c0,0,1.48,7.73,5.32,8.26"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default ConsultationIcon
